import _typeof from "@babel/runtime/helpers/typeof";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _merge from "lodash/merge";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import "core-js/modules/es6.regexp.replace.js";
import analytics from '@nerdwallet/analytics';
import { gql } from '@nerdwallet/apollo';
import { PRODUCT_DISPLAY_DRIVER } from './constants';
/**
 * Returns all fields expected by product_shopping_attributes
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/product_shopping_attributes.yaml
 */

var getProductShoppingAttributes = function getProductShoppingAttributes(_ref) {
  var analyticsProps = _ref.analyticsProps,
      monetizable = _ref.monetizable,
      productType = _ref.productType;
  return {
    marketplace_product_type: productType,
    marketplace_institution_id: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.institutionId,
    marketplace_product_id: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.productId,
    marketplace_offer_id: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.offerId,
    monetizable: monetizable,
    driver: PRODUCT_DISPLAY_DRIVER
  };
};

getProductShoppingAttributes.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment getProductShoppingAttributes on MarketplaceEntityInterface {\n    productType\n\n    ... on MarketplaceEntityWithPlacementInterface {\n      analyticsProps {\n        institutionId\n        offerId\n        productId\n      }\n      monetizable\n    }\n  }\n"])));
/**
 * Returns all payload fields expected by the product_impression event
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/product_impression.yaml
 */

export var getProductImpressionPayload = function getProductImpressionPayload(gqlMarketplaceEntity) {
  return _objectSpread({}, getProductShoppingAttributes(gqlMarketplaceEntity));
};
getProductImpressionPayload.fragment = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fragment getProductImpressionPayload on MarketplaceEntityInterface {\n    ...getProductShoppingAttributes\n  }\n  ", "\n"])), getProductShoppingAttributes.fragment);
/**
 * Returns all payload fields expected by the shopping_finished event
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/shopping_finished.yaml
 */

var getShoppingFinishedPayload = function getShoppingFinishedPayload(gqlMarketplaceEntity) {
  var _window, _window$location;

  return _objectSpread({
    // We need to strip the hyphens since shopping_finished IDs are special (defined as ^[A-Za-z0-9]{32}$ and not as a guid)
    shopping_finish_id: analytics.uuid().replace(/-/g, ''),
    finish_type: 'internal_content',
    source_url_simple: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href,
    bot_suspected: false
  }, getProductShoppingAttributes(gqlMarketplaceEntity));
};

getShoppingFinishedPayload.fragment = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fragment getShoppingFinishedPayload on MarketplaceEntityInterface {\n    ...getProductShoppingAttributes\n  }\n  ", "\n"])), getProductShoppingAttributes.fragment);
export var trackNonMonetizingShoppingFinished = function trackNonMonetizingShoppingFinished(gqlMarketplaceEntity, payloadOverrides) {
  // Avoid executing this function in SSR
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return;
  }

  analytics.track('shopping_finished', _merge(getShoppingFinishedPayload(gqlMarketplaceEntity), payloadOverrides));
};
trackNonMonetizingShoppingFinished.fragment = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  fragment trackNonMonetizingShoppingFinished on MarketplaceEntityInterface {\n    ...getShoppingFinishedPayload\n  }\n  ", "\n"])), getShoppingFinishedPayload.fragment);